import { getImageUrl } from './api';

/**
 * Fix image URLs in HTML content
 * Converts relative paths like /uploads/images/xyz.jpg to absolute URLs
 * @param {string} htmlContent - HTML content to process
 * @returns {string} - HTML content with fixed image URLs
 */
export const fixImageUrlsInHtml = (htmlContent) => {
  if (!htmlContent) return '';
  
  // Create a temporary container to parse HTML
  const temp = document.createElement('div');
  temp.innerHTML = htmlContent;
  
  // Find all img tags
  const images = temp.querySelectorAll('img');
  
  images.forEach((img) => {
    const src = img.getAttribute('src');
    if (src) {
      // Convert relative URLs to absolute URLs
      if (src.startsWith('/uploads/') || (!src.startsWith('http://') && !src.startsWith('https://'))) {
        const fixedUrl = getImageUrl(src);
        img.setAttribute('src', fixedUrl);
      }
    }
  });
  
  return temp.innerHTML;
};

/**
 * Fix both image URLs in HTML content AND remove the first image
 * @param {string} htmlContent - HTML content to process
 * @returns {string} - Processed HTML
 */
export const processArticleHtml = (htmlContent) => {
  if (!htmlContent) return '';
  
  // Create a temporary container to parse HTML
  const temp = document.createElement('div');
  temp.innerHTML = htmlContent;
  
  // Remove the first image (hero image is shown separately)
  const firstImg = temp.querySelector('img');
  if (firstImg) {
    firstImg.remove();
  }
  
  // Fix all remaining image URLs
  const images = temp.querySelectorAll('img');
  images.forEach((img) => {
    const src = img.getAttribute('src');
    if (src) {
      // Convert relative URLs to absolute URLs
      if (src.startsWith('/uploads/') || (!src.startsWith('http://') && !src.startsWith('https://'))) {
        const fixedUrl = getImageUrl(src);
        img.setAttribute('src', fixedUrl);
      }
    }
  });
  
  return temp.innerHTML;
};

const htmlProcessor = {
  fixImageUrlsInHtml,
  processArticleHtml
};

export default htmlProcessor;
